import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface ListQueryParams {
  page: number
  limit: number
  device_id: string
  key_word?: string
}

export interface SoftwareInfo {
  soft_id: number
  soft_name: string
  version: string
  install_time: number
  soft_hash_key: string
  display_name: string
}

export interface SoftwareUninstallParams {
  uninstall_type: 0 | 1
  device_id: string
  soft_hash_keys: string[]
}

@Injectable()
export class InstalledDetailService {
  constructor (private http: Http) {}

  @ParamsClean()
  @InvokeThrottle()
  getSoftwareList (params: Partial<ListQueryParams>) {
    return this.http.post<{
      total: number
      list: SoftwareInfo[]
    }>('/softmgr/soft/list', params)
  }

  download (type: 0|1, options: ListQueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0,
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/soft/list/export', params, moduleName)
  }

  uninstallSoftware (params: SoftwareUninstallParams) {
    return this.http.post('/terminal-order/terminal-uninstall-soft', params)
  }
}
